module.exports = __webpack_public_path__ + "static/media/classics-10217_03.c557f668.png";